import PubSub from './pubsub.js';

if (!customElements.get("cart-drawer-toggle")) {

  class CartDrawerToggle extends HTMLElement {
    constructor() {
      super();

      this.pubsub = PubSub;

      this.toggleBtn = this.querySelector('button[data-cart-drawer-toggle]');
      this.drawer = document.querySelector('div[data-cart-drawer]');
      this.overlay = document.querySelector('div[data-cart-drawer-overlay]');

      this.cartOpen = false;

    }

    // TOGGLE
    handleDelegateClick(e) {
      if (e.target.matches('button[data-cart-drawer-open]')) {
        // console.log("DELEGATE OPEN");
        this.open();
      } else if (e.target.matches('button[data-cart-drawer-close]')) {
        // console.log("DELEGATE CLOSE");
        this.close();
      } else if (e.target.matches('[data-cart-drawer-overlay]')) {
        // console.log("DELEGATE CLOSE");
        this.close();
      }
    }
 
    // OPEN
    open() {
      this.cartOpen = true;

      this.drawer.classList.remove('animate__slideOutRight');
      this.drawer.classList.add('animate__slideInRight', 'animate__animated');
      this.drawer.style.display = 'block';

      this.overlay.classList.remove('hidden', 'animate__fadeOut');
      this.overlay.classList.add('animate__fadeIn', 'animate__animated');
      this.overlay.style.display = 'block';

      document.querySelector('body').classList.add('overflow-hidden');
    }

    // CLOSE
    close() {
      this.cartOpen = false;

      this.drawer.classList.remove('animate__slideInRight');
      this.drawer.classList.add('animate__slideOutRight', 'animate__animated');
      this.drawer.addEventListener('animationend', () => {
        if (!this.isOpen) {
          this.drawer.style.display = 'none';
        }
      }, { once: true });

      this.overlay.classList.remove('animate__fadeIn');
      this.overlay.classList.add('animate__fadeOut', 'animate__animated');
      this.overlay.addEventListener('animationend', () => {
        if (!this.isOpen) {
          this.overlay.style.display = 'none';
          this.overlay.classList.add('hidden');
        }
      }, { once: true });

      document.querySelector('body').classList.remove('overflow-hidden');
    }

    handleCartAdd() {
      this.open();
    }

    connectedCallback() {
      // this.toggleBtn.addEventListener('click', this.handleToggle.bind(this));
      document.addEventListener('click', this.handleDelegateClick.bind(this));

      this.overlay.addEventListener('click', this.close);
      this.pubsub.sub("cart:add", this.handleCartAdd.bind(this));
    }

    disconnectedCallback() {
      // this.toggleBtn.removeEventListener('click', this.handleToggle.bind(this));
      document.removeEventListener('click', this.handleDelegateClick.bind(this));

      this.overlay.removeEventListener('click', this.close);
      this.pubsub.unsub("cart:add", this.handleCartAdd.bind(this));
    }
  }

  customElements.define('cart-drawer-toggle', CartDrawerToggle);
}